/*
  <fw-accordion> — single-open accordion group
  --------------------------------------------
  One open item per group; click a head to toggle. Scoped to `this` (the custom
  element instance) so multiple accordions on one page never collide.

  Markup contract (rendered by Liquid):
    <fw-accordion>
      <div class="fw-accordion__item is-open?">
        <button class="fw-accordion__head" aria-expanded="true|false" aria-controls="ID">
          ...<span class="fw-accordion__label">...</span>
        </button>
        <div class="fw-accordion__body" id="ID" role="region">...</div>
      </div>
      ...
    </fw-accordion>

  Self-contained, namespaced, registered once.
*/
(function () {
  if (customElements.get('fw-accordion')) return;

  customElements.define(
    'fw-accordion',
    class FwAccordion extends HTMLElement {
      connectedCallback() {
        this._onClick = this._onClick.bind(this);
        this.addEventListener('click', this._onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
      }

      _onClick(event) {
        var head = event.target.closest('.fw-accordion__head');
        if (!head || !this.contains(head)) return;

        var item = head.closest('.fw-accordion__item');
        if (!item) return;

        var wasOpen = item.classList.contains('is-open');

        // Close every item in this group.
        this.querySelectorAll('.fw-accordion__item').forEach(function (it) {
          it.classList.remove('is-open');
          var h = it.querySelector('.fw-accordion__head');
          if (h) h.setAttribute('aria-expanded', 'false');
        });

        // Open the clicked one unless it was already open (click to collapse).
        if (!wasOpen) {
          item.classList.add('is-open');
          head.setAttribute('aria-expanded', 'true');
        }
      }
    }
  );
})();
